import React from "react";
import { API_BASE } from "@/lib/api";

// Shows a company's white-label logo when available, else the default Suvera Flow logo.
export function CompanyLogo({ logoUrl, className = "h-8", light = false, alt = "Company" }) {
  const src = logoUrl ? `${API_BASE.replace(/\/api$/, "")}${logoUrl}` : light ? "/logo-white.webp" : "/logo.webp";
  return (
    <div className={`flex items-center ${className}`}>
      <img src={src} alt={alt} className="h-full w-auto object-contain" data-testid="company-logo" />
    </div>
  );
}
